export default __webpack_public_path__ + "static/media/transaction-management-2.342de141.svg";